import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const QuantityBox = ({ quantity }) => {
  const { t } = useTranslation();
  if (!quantity) {
    return null;
  }
  return (
    <div className='dln-orderRev__wrap dln-orderRev__wrap--quantity'>
      <span className='dln-orderRev__quantity'>
        {t('cart:cart.miniCart.quantity')} {quantity}
      </span>
    </div>
  );
};

QuantityBox.propTypes = {
  quantity: PropTypes.number,
};

QuantityBox.defaultProps = {
  quantity: null,
};

export default QuantityBox;
